import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './ChatBadge.scss';

const VARIATIONS = {
  practice: {
    emoji: '🎯',
    translationKey: 'Practice Mode',
  },
  study: {
    emoji: '✨',
    translationKey: 'Study Mode',
  },
};

function ChatBadge({ className, variation }) {
  const { t } = useTranslation(['chatbot']);
  const selectedVariation = VARIATIONS[variation] || VARIATIONS.study; // Default to study if invalid

  const componentClass = classNames('chat-badge', `chat-badge--${variation}`, className);

  return (
    <div className={componentClass}>
      <span className="chat-badge__emoji" role="img" aria-hidden="true">
        {selectedVariation.emoji}
      </span>
      <span className="chat-badge__text">{t(selectedVariation.translationKey)}</span>
    </div>
  );
}

ChatBadge.propTypes = {
  className: PropTypes.string,
  variation: PropTypes.oneOf(['practice', 'study']).isRequired,
};

ChatBadge.defaultProps = {
  className: '',
};

export default ChatBadge;
